import { UserInfoProps } from "@/store";

// 更改内存中的登录信息
export const setUserInfo = (user: UserInfoProps) => {
  USER_INFO.isLogin = user.isLogin;
  USER_INFO.platform = user.platform;
  USER_INFO.githubName = user.githubName;
  USER_INFO.githubHeadImg = user.githubHeadImg;
  USER_INFO.wechatName = user.wechatName;
  USER_INFO.wechatHeadImg = user.wechatHeadImg;
  USER_INFO.companyName = user.companyName;
  USER_INFO.companyHeadImg = user.companyHeadImg;
  USER_INFO.qqName = user.qqName;
  USER_INFO.qqHeadImg = user.qqHeadImg;
  USER_INFO.role = user.role;
  USER_INFO.token = user.token;
  USER_INFO.user_id = user.user_id;
  USER_INFO.checkPlugin = user.checkPlugin;
};

// user info
export const USER_INFO: UserInfoProps = {
  /** 是否登录 */
  isLogin: false,
  /** 登录平台 */
  platform: null,
  githubName: null,
  githubHeadImg: null,
  wechatName: null,
  wechatHeadImg: null,
  companyName: null,
  companyHeadImg: null,
  qqName: null,
  qqHeadImg: null,
  /** 角色 */
  role: null,
  token: "",
  user_id: 0,
  /** 是否有插件管理权限 */
  checkPlugin: false,
};
export const HttpSetting = {
  httpBaseURL: "",
};
